import { React, useState, useEffect, useRef } from "react";
import { Header } from "../../components/common/Header.js";
import { useParams } from "react-router-dom";
import { SideBar } from "../../features/SideBar/SideBar.js";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { getDetail } from "../DetailsPage/DetailSlice.js";
//Utility
import { filterNominees } from "../../utility/utility.js";
import { getCurrentWeekRange } from "../../utility/utility.js";
import { movieCollections } from "../../resources/Collections/tmdbCollection.js";
//Styling
import "./RcmPage.css";
//Child Comp
import { CategoryShowcase } from "../../features/MovieShowcase/CategoryShowcase.js";
import { CollectionShowCase } from "../../features/MovieShowcase/CollectionShowcase.js";
//Test
import { categoryData } from "../../resources/Awards/thetvdbData.js";
import { MovieTagCarousel } from "../../features/MovieTag/MovieTagCarousel.js";

export const RcmPage = (props) => {
  let category_data = filterNominees(categoryData, 1, 1, [2023], false);
  let category_data2 = filterNominees(categoryData, 1, 1, [2019], true);


  let trendingMov = useSelector(
    (state) => state.apiUtility.apiUtility.trendingMov
  );
  let trendingTv = useSelector(
    (state) => state.apiUtility.apiUtility.trendingTv
  );

  function getRandomCollection(collection, numberOfItems) {
    const shuffled = collection.sort(() => Math.random() - 0.5);
    return shuffled.slice(0, numberOfItems);
  }

  return (
    <>
      <div className="rcm-page">
        <Header />
        <div className="rcm_page_wrapper">
          <div className="rcm_page_title">
            GET SOME <br />
            RECOMMENDATIONS
          </div>
          <div className="rcm_page_content_wrapper">
            <div className="rcm_section section_1">
              <div className="rcm_section_title">
                Critically Acclaimed Cinema
              </div>
              <div className="rcm_section_content">
                <div className="rcm_section_item">
                  <CategoryShowcase categoryData={category_data} />
                </div>
                <div className="rcm_section_item">
                  <CategoryShowcase categoryData={category_data2} />
                </div>
              </div>
            </div>
            <div className="rcm_section section_2">
              <div className="rcm_section_title">Blockbuster Collections</div>
              <div className="rcm_section_content">
                {getRandomCollection(movieCollections, 2).map((item, index) => (
                  <div className="rcm_section_item" key={index}>
                    <CollectionShowCase collectionId={item.id} />
                  </div>
                ))}
              </div>
            </div>
            <div className="rcm_section section_3">
              <div className="rcm_section_title">
                Hot Picks: Trending Movies and TV Shows
              </div>
              <div className="rcm_section_content">
                <div className="rcm_section_item">
                  <div className="rcm_section_item_title">{`Buzzworthy Flick from ${getCurrentWeekRange()}`}</div>
                  <MovieTagCarousel
                    movieItems={trendingMov}
                    isGrid={true}
                    isDefaultSmall={true}
                    movieType={"mov"}
                    isHoverEnable={true}
                  />
                </div>
                <div className="rcm_section_item">
                  <div className="rcm_section_item_title">{`Trendsetting Series from ${getCurrentWeekRange()}`}</div>
                  <MovieTagCarousel
                    movieItems={trendingTv}
                    isGrid={true}
                    isDefaultSmall={true}
                    movieType={"tv"}
                    isHoverEnable={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBar />
    </>
  );
};
